import { inject, Pipe, PipeTransform } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { LexplusPermissionsEnum } from '@lexplus-authentication-api';

@Pipe({
  name: 'hasPermissionsForRoute',
})
export class HasPermissionsForRoutePipe implements PipeTransform {
  private readonly permissionsService = inject(PermissionsService);

  public transform(routeId: string): boolean {
    switch (routeId) {
      case 'USER_TASKS':
        return (
          this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAufgabenReadonly) ||
          this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAufgabenEigene) ||
          this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAufgabenAlle)
        );
      case 'USER_REPORTS_ANALYSIS':
        return this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAuswertungen);
      case 'USER_ADMINISTRATION_USER_MANAGEMENT':
        return this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAdministrationBenutzerverwaltung);
      case 'USER_ADMINISTRATION_LEXPLUS_CONFIG':
        return this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserAdministrationLexpluskonfiguration);
      case 'USER_DOCUMENT_MANAGER':
        return this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserDokumentenmanager);
      case 'USER_DOWNLOADS':
        // A newsletter subscriber reaches the Newsletter tab without any download right.
        return (
          this.permissionsService.hasPermissions(LexplusPermissionsEnum.UserDownloadsBasis) ||
          this.permissionsService.isNewsletterSubscriber()
        );
      default:
        return true;
    }
  }
}
